import React, { useEffect, useState, useRef, useContext, useMemo } from 'react';
import { debounce } from 'lodash';
import APIService from '@shared/services/api';
import Notify from '@shared/notify';
import TextInput from '@shared/component/TextInput';
import List from '@shared/component/List';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import CheckValidator from '@shared/checkValidator';
import Lists from '@shared/component/Lists';
import { ActionValues, actionsPermissionValidator } from '@utils/static/commonUtils';
interface FormData {
    name?: null;
    // Add more fields as needed
}
export function Categories() {
    const [errors, setError] = useState<any>({
        name: {
            required: true,
            error: true,
            message: 'Please enter name',
            pattern: /^[A-Za-z][A-Za-z0-9\s.&]*$/, ///^[A-Za-z0-9\s]*$/,
            maxLength: 50,
        },
    });
    const listRef: any = useRef(null);
    const { setLoader } = useContext(AuthContext);
    const [categories, setCategories] = useState([]);
    const [id, setId] = useState(null);

    const [isSubmit, setIsSubmit] = useState(false);
    const [recordCount, setRecordCount] = useState(0);
    const [formData, setFormData] = useState<any>({ name: null });
    const [currentPage, setCurrentPage] = useState(1);
    const [showHideModel, setShowHideModel] = useState(false);
    const [edit, setEdit] = useState(false);
    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
        } catch (error) {}
    };
    const [columns, setColumns] = useState({
        id: 'ID',
        name: 'Name',
        items: 'Item',
        status: 'Status',
        // action: 'Action',
        ...(actionsPermissionValidator(location.pathname, ActionValues.Edit) ? { action: 'Action' } : null),
    });

    const getCategory = async (page: any = 1) => {
        try {
            setCurrentPage(page);
            setLoader(true);
            const apiUrl = `category/?page=${page}&sort=createdAt`;
            const data = await APIService.getAll(apiUrl, true, false);
            setCategories(data.data.data);
            setRecordCount(data?.data?.count || 0);
            setLoader(false);
        } catch (err) {
            setLoader(false);
        }
    };

    useEffect(() => {
        getCategory();
    }, []);

    const addCategory = async () => {
        try {
            const isValid = await CheckValidator(errors, formData);
            setIsSubmit(!isValid);
            if (isValid) {
                setLoader(true);
                const updateddata = await APIService.post('category', formData, true, true);
                setLoader(false);
                if (updateddata.status === 200) {
                    setEdit(false);
                    handelModel(false);
                    setFormData({
                        ['name']: null,
                    });
                    Notify('success', 'Category added successfully');
                    getCategory();
                    listRef.current.clearSearchBox();
                }
            } else {
                // Notify('error', 'Please enter valid category name');
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const searchCategory = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const data = await APIService.getAll(
                `category/search/get?page=${page}&order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );
            setCategories(data.data.data);
            setRecordCount(data?.data?.count || 0);
        } catch (err) {}
    };

    const updateStatus = async (item: any, status: any, id: any, page: any, search: any) => {
        try {
            const data = {
                status: status,
            };
            setLoader(true);
            const updateddata = await APIService.update('category/status', id, data, true, true);
            setLoader(false);
            if (updateddata.status === 200) {
                Notify('success', 'Category status updated');
                searchCategory(search.trim(), page);
                // getCategory(currentPage);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const updateCategory = async () => {
        try {
            setIsSubmit(true);
            const isValid = await CheckValidator(errors, formData);
            if (isValid) {
                setLoader(true);
                const updateddata = await APIService.update('category', id, formData, true, true);
                setLoader(false);
                if (updateddata.status === 200) {
                    Notify('success', 'Category updated successfully');

                    setEdit(false);
                    handelModel(false);
                    setFormData({
                        ['name']: null,
                    });
                    getCategory(currentPage);
                    listRef.current.clearSearchBox(true);
                }
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const getCategoryById = async (id: any) => {
        try {
            setLoader(true);
            const updateddata = await APIService.getById('category', id, true, false);
            setLoader(false);
            if (updateddata.status === 200) {
                setId(updateddata.data.data.id);

                setFormData({
                    ['name']: updateddata.data.data.name,
                });
                setEdit(true);
                handelModel(true);
            }
        } catch (err) {
            setLoader(false);
        }
    };

    const getValue = (e: any) => {
        try {
            const data = { ...formData, ...e };
            setFormData(data);
        } catch (error) {}
    };

    const getDeleteIds = async (ids: any) => {
        try {
            const data = {
                ids: JSON.stringify(ids),
            };
            setLoader(true);
            const updateddata = await APIService.post('category/delete/category', data, true, true);
            setLoader(false);
            Notify('success', 'Category deleted  successfully');
            getCategory();
        } catch (error) {
            setLoader(false);
        }
    };

    const handlereset = () => {
        setEdit(false);
        setFormData({
            ['name']: null,
        });
        handelModel(false);
    };

    return (
        <div className="container dash-container">
            <div className="dash_bread_box">
                <ul>
                    <li>App User Category</li>
                </ul>
            </div>
            <div className="content_body_cover">
                <Lists
                    ref={listRef}
                    headers={columns}
                    data={categories}
                    handelModel={(e: boolean) => handelModel(e)}
                    searchItem={searchCategory}
                    type={'add+delete'}
                    getDeleteIds={getDeleteIds}
                    addUpdateText="Category"
                    recordCount={recordCount}
                    callPagination={getCategory}
                    getById={getCategoryById}
                    updateStatus={updateStatus}
                />

                {showHideModel && (
                    <Modal show={true} onHide={() => handlereset()} backdrop="static" size={'md'} keyboard={false}>
                        <Modal.Header closeButton>
                            <Modal.Title> {edit ? 'Edit Category' : 'Add Category'}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="material_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="field_box field_no_margin">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="form-floating ">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Category Name',
                                                            name: 'name',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="name"
                                                        isSubmit={isSubmit}
                                                        value={formData.name}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.name.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button
                                variant="secondary"
                                className="btn dark_btn custom_btn"
                                onClick={edit ? updateCategory : addCategory}
                            >
                                {edit ? 'Update' : 'Add'}
                            </Button>
                            <Button
                                variant="default"
                                className="btn custom_btn border_btn with_icon"
                                onClick={() => {
                                    handlereset();
                                }}
                            >
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Modal>
                )}
            </div>
        </div>
    );
}
